export default {
  name: 'Silk Stream',
  enableHomeSignUp: true,
  gymId: '5d8e1e56c6f34f3df9bac233',
  email: 'centralcompliance@rmguk.com',
  styles: {
    fontFamily: 'Montserrat',
    primary: '#4a4a49',
    secondary: '#7cb3ca',
    accent: '#939799',
    accentDark: '#4a4a49'
  },
  isHomepageHeroDark: true,
  locationsPage: {
    showUpcomingEvents: false,
    upcomingEventsClassTypes: ['class', 'induction']
  }
};
